module.exports = __webpack_public_path__ + "img/hello_home_page_3.4d7c5528.png";